import { useEffect, useRef } from 'react'
import { AUTHOR, APP_VERSION_LABEL } from '../version'
import { Icon } from './Icon'

export function HelpDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const dialogRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const previous = document.activeElement instanceof HTMLElement ? document.activeElement : null
    const overflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    dialogRef.current?.focus()
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => {
      window.removeEventListener('keydown', onKey)
      document.body.style.overflow = overflow
      previous?.focus()
    }
  }, [open, onClose])

  if (!open) return null
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <div className="modal-card help-card" role="dialog" aria-modal="true" aria-labelledby="help-title" ref={dialogRef} tabIndex={-1}>
        <div className="modal-heading">
          <div>
            <span className="eyebrow">Investment Course · {APP_VERSION_LABEL}</span>
            <h2 id="help-title">How the course works</h2>
          </div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Close help"><Icon name="close" /></button>
        </div>
        <div className="help-grid">
          <section><h3>Learn your way</h3><p>Use the eight-course path, search all 105 modules, or resume exactly where you stopped. Each lesson is divided into manageable sections.</p></section>
          <section><h3>Track progress</h3><p>Mark a section complete when you finish it. Guest progress stays in this browser. After choosing AI and signing in, progress can follow you across devices.</p></section>
          <section><h3>Use AI only when useful</h3><p>Open Ask AI for a general question, or use inline AI help in a module section. Sign-in happens on the separate Account page. AI runs only when you send a question.</p></section>
          <section><h3>Privacy and reliability</h3><p>The course works without an account. If cloud sync is unavailable, progress remains saved locally and retries later.</p></section>
        </div>
        <div className="notice info"><strong>Educational only—not financial advice.</strong> AI responses can be incomplete or wrong. Verify current tax, legal, investment, and benefit information with primary sources or a qualified professional.</div>
        <p className="small muted">{AUTHOR} · {APP_VERSION_LABEL}</p>
      </div>
    </div>
  )
}
